import { getClassLevel } from "../shared/getClassLevel";
import { evaluateEmpoweredEvocation } from "./evokerAttacks";

const wizardAdapter = Object.freeze({
  id: "wizard",
  getClassLevel: (character) => getClassLevel(character, "wizard"),
  evaluateOnHit: (context) => [evaluateEmpoweredEvocation({ context })],
});

export default wizardAdapter;
